<button mat-icon-button class="bg-gray-200" (click)="show = !show" > <mat-icon>{{ show ? show_icon : hidden_icon }}</mat-icon> </button>
